import { render } from "./BaseDescktopView.vue?vue&type=template&id=4b262926&scoped=true"
import script from "./BaseDescktopView.vue?vue&type=script&lang=js"
export * from "./BaseDescktopView.vue?vue&type=script&lang=js"

import "./BaseDescktopView.vue?vue&type=style&index=0&id=4b262926&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b262926"]])

export default __exports__